import React from 'react';
import {
  PawPrint,
  ShieldCheck,
  Clock,
  UsersThree,
  MapPin,
  Heart,
} from '@phosphor-icons/react';
import ServicePage from './services/ServicePage';

const facilities = [
  { icon: PawPrint, title: 'Daily walks', label: 'Daily walks', sub: 'Trained walkers, GPS-tracked routes' },
  { icon: ShieldCheck, title: 'Background-checked team', label: 'Background-checked team', sub: 'Trained, insured, vet-aligned' },
  { icon: MapPin, title: 'Live GPS tracking', label: 'Live GPS tracking', sub: 'Route and pace in real time' },
  { icon: Heart, title: 'Soft leash handling', label: 'Soft leash handling', sub: 'Gentle, dog-first technique' },
  { icon: Clock, title: 'Flexible scheduling', label: 'Flexible scheduling', sub: 'Book once, repeat weekly' },
  { icon: UsersThree, title: 'Trusted by pet parents', label: 'Trusted by pet parents', sub: 'Photo updates after every walk' },
];

const heroFeatures = [
  { icon: ShieldCheck, label: 'Trained & verified walkers', sub: 'Background-checked care' },
  { icon: PawPrint, label: 'Safe, hygienic care', sub: 'Dog-first handling' },
  { icon: UsersThree, label: 'Trusted by pet parents', sub: 'Live updates after every walk' },
];

const gallery = [
  {
    url: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=1200&q=80',
    title: 'Walks, done right',
    description: 'Small groups, consistent walkers, live updates.',
  },
  {
    url: 'https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?auto=format&fit=crop&w=1200&q=80',
    title: 'Familiar routes',
    description: 'Neighbourhood paths chosen for safety and energy.',
  },
  {
    url: 'https://images.pexels.com/photos/7179466/pexels-photo-7179466.jpeg?auto=compress&cs=tinysrgb&w=1600',
    title: 'Everyday adventures',
    description: 'Paced to your dog, with a walker you can trust.',
  },
];

const highlights = [
  'Live route and check-in updates on every walk',
  'Same walker where possible — routine matters',
  'Photo set delivered after every session',
  'Doorstep pickup and drop for weekday walks',
];

const Freshtails = () => (
  <ServicePage
    eyebrow="A PetCart venture"
    title="Fresh in every way. Happy every day."
    phrases={['Fresh in every way.', 'Happy every day.']}
    lede="Daily walks with trained walkers. Everything your dog needs to stay fresh, healthy and happy."
    logo="/images/logo-freshtails.png"
    logoAlt="Freshtails"
    heroImage="/images/view.png"
    heroAlt="Freshtails team caring for a dog"
    heroTone="forest"
    heroFeatures={heroFeatures}
    intro="Freshtails is the everyday walking side of PetCart — trained walkers, live updates, and a routine that flexes with your week."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Daily walks, made simple"
    closingBody="Book a walk or set up a recurring plan — and let Freshtails handle the rest."
    ctaLabel="Get started"
    ctaHref="https://freshtails.zopnote.com/signup"
  />
);

export default Freshtails;
